import { render, staticRenderFns } from "./RoundingSettings.vue?vue&type=template&id=6610c196&"
import script from "./RoundingSettings.vue?vue&type=script&lang=js&"
export * from "./RoundingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports